<div id="sub-breadcrumb">
	<!-- &nbsp;<nav class="breadcrumbs" >
		<a *ngFor="let step of steps; let i = index" class="breadcrumbs__item" [class.is-active]="step.currentStep">{{i+1}}</a>
	</nav>
	<br>
	 -->
	<!-- Heading that changes based on the breadcrumb -->
	 <br>
	<div class="form-heading">
		<h4>{{currentHeading}}</h4>
		<div class="heading-border"></div>
	  </div>
	  

</div>
